import { EuiSpacer } from '@elastic/eui';
import InfoTable from 'components/Web_User_Interface/720p_Series/System/Info/infoTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  InfoTable,
  BreadCrumbs,
  SEOHelmet,
  React
};